import React from 'react';
import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Chip,
  LinearProgress,
  Typography,
  Grid,
} from '@mui/material';
import PropTypes from 'prop-types';

/**
 * TableShowcase Component
 * Displays table with theme styling
 */
const TableShowcase = ({ theme }) => {
  return (
    <Grid size={{ xs: 12 }}>
      <Typography variant="subtitle2" gutterBottom>
        Table
      </Typography>
      <Table sx={{ backgroundColor: theme.surface_color }}>
        <TableHead>
          <TableRow sx={{ backgroundColor: theme.primary_color }}>
            <TableCell sx={{ color: '#ffffff', fontFamily: theme.font_family }}>
              Name
            </TableCell>
            <TableCell sx={{ color: '#ffffff', fontFamily: theme.font_family }}>
              Status
            </TableCell>
            <TableCell sx={{ color: '#ffffff', fontFamily: theme.font_family }}>
              Progress
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell sx={{ color: theme.text_color }}>Project A</TableCell>
            <TableCell>
              <Chip
                label="Active"
                size="small"
                sx={{
                  backgroundColor: theme.success_color || '#4caf50',
                  color: '#ffffff',
                }}
              />
            </TableCell>
            <TableCell>
              <LinearProgress
                variant="determinate"
                value={75}
                sx={{
                  backgroundColor: theme.surface_color,
                  '& .MuiLinearProgress-bar': {
                    backgroundColor: theme.primary_color,
                  },
                }}
              />
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell sx={{ color: theme.text_color }}>Project B</TableCell>
            <TableCell>
              <Chip
                label="Pending"
                size="small"
                sx={{
                  backgroundColor: theme.warning_color || '#ff9800',
                  color: '#ffffff',
                }}
              />
            </TableCell>
            <TableCell>
              <LinearProgress
                variant="determinate"
                value={35}
                sx={{
                  backgroundColor: theme.surface_color,
                  '& .MuiLinearProgress-bar': {
                    backgroundColor: theme.secondary_color,
                  },
                }}
              />
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </Grid>
  );
};

TableShowcase.propTypes = {
  theme: PropTypes.object.isRequired,
};

export default TableShowcase;
